import type { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { googleFontsStylesheetUrl } from "@/utils/googleFonts";
import {
  type WebsiteDesignSettingsTheme,
  uniqueGoogleFontFamilies,
  websiteDesignBodyFontFamily,
  websiteDesignCssVariables,
} from "@/utils/websiteDesignTheme";

interface WebsiteThemeScopeProps {
  settings: WebsiteDesignSettingsTheme | null | undefined;
  children: ReactNode;
}

export function WebsiteThemeScope({ settings, children }: WebsiteThemeScopeProps) {
  const fontFamilies = uniqueGoogleFontFamilies(settings);
  const cssVars = websiteDesignCssVariables(settings);
  const bodyFontFamily = websiteDesignBodyFontFamily(settings);

  return (
    <>
      <Helmet>
        {fontFamilies.map((family) => {
          const href = googleFontsStylesheetUrl({ family });
          if (!href) return null;
          return (
            <link
              key={family}
              rel="stylesheet"
              href={href}
            />
          );
        })}
      </Helmet>
      <div
        className="website-theme"
        style={{
          ...cssVars,
          ...(bodyFontFamily ? { fontFamily: bodyFontFamily } : {}),
        }}
      >
        <style>{`
          .website-theme h1,
          .website-theme h2,
          .website-theme h3,
          .website-theme h4,
          .website-theme h5,
          .website-theme h6 {
            font-family: var(--heading-font, inherit);
            color: var(--heading-color, inherit);
          }
        `}</style>
        {children}
      </div>
    </>
  );
}
